import { NavigationService } from "@/shared/services/NavigationService";
import { Component, Vue, Watch } from "vue-property-decorator";
import { RouteMapData } from "./model/RouteMap";
import { DASHBOARD_PRINCIPAL } from "./../../../modules/Dashboards/constants/DashboardConstants";
import { DashboardCard } from "@/modules/Dashboards/models/DashboardCard";
import {
  GENERAL_CONSTANTS,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { Utils } from "@/shared/utils/utils";
import { mapGetters } from "vuex";
import store from "@/store";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import {
  PROFILE_CRUMBS_CONSTANTS,
  PROFILE_CONSTANTS
} from "@/modules/Profile/constants/ProfileConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";

@Component({
  name: "RouteMap",
  components: {
    ModalTemplate
  },
  computed: {
    ...mapGetters({
      profileCrumbs: "getProfileCrumbles",
      serviceOnChangeValidation: "getOnChangeServiceValidation"
    })
  }
})
export default class RouteMap extends Vue {
  profileCrumbs!: MenuDataStructure;
  routeMap: RouteMapData[] = [];
  nameRoute = "";
  GO_TO = GENERAL_CONSTANTS.ROUTES.GO_TO;
  serviceOnChangeValidation!: boolean;
  dialogFormModal = false;
  modalText = PROFILE_CONSTANTS.DIALOG_MESSAGES.CHANGE_SERVICE_TEXT;
  modalTitle = PROFILE_CONSTANTS.DIALOG_MESSAGES.CHANGE_SERVICE_TITLE;
  routeMapDataHandle!: RouteMapData;
  crumbleValidation = false;

  get isExternalChatAssistant(): boolean {
    return (
      this.$route.name === "ChatAssistant" &&
      (localStorage.getItem("ROLE") ?? "")
        .split(",")
        .some(role => role.trim().toUpperCase() === "EXTERNO")
    );
  }

  mounted() {
    this.calculeRoute();
  }
  @Watch("serviceOnChangeValidation")
  watchServiceOnChangeValidation() {
    return this.serviceOnChangeValidation;
  }

  @Watch("profileCrumbs")
  handleProfileCrumbles() {
    if (this.profileCrumbs != ({} as MenuDataStructure)) {
      if (this.profileCrumbs.type == PROFILE_CRUMBS_CONSTANTS.TYPE.INITIAL) {
        this.routeMap.push({
          title: this.profileCrumbs.data.userName ?? this.profileCrumbs.action,
          pathName: PROFILE_CRUMBS_CONSTANTS.ROUTES.INITIAL,
          profileCrumble: true
        });
      } else if (
        this.profileCrumbs.type == PROFILE_CRUMBS_CONSTANTS.TYPE.SERVICE_ADDED
      ) {
        const index = this.routeMap.findIndex(
          route => route.pathName == PROFILE_CRUMBS_CONSTANTS.ROUTES.SERVICE
        );
        if (index != -1) {
          this.routeMap.splice(index, 1);
        }
        this.routeMap.push({
          title: this.profileCrumbs.data.service ?? this.profileCrumbs.action,
          pathName: PROFILE_CRUMBS_CONSTANTS.ROUTES.SERVICE,
          profileCrumble: true
        });
      } else if (
        this.profileCrumbs.from == PROFILE_CRUMBS_CONSTANTS.FROM.PROFILE &&
        this.profileCrumbs.type == PROFILE_CRUMBS_CONSTANTS.TYPE.SERVICE_REMOVED
      ) {
        const indexRoute = this.routeMap.findIndex(
          route => route.pathName == PROFILE_CRUMBS_CONSTANTS.ROUTES.SERVICE
        );
        this.routeMap.splice(indexRoute, 1);
      }
    }
  }

  calculeRoute() {
    this.routeMap = [];
    if (this.$route && this.$route.name) {
      this.nameRoute = this.$route.name;
      if (this.nameRoute == GENERAL_CONSTANTS.ROUTES.HOME) {
        return;
      }
    }
    const route: RouteMapData = {
      title: GENERAL_CONSTANTS.ROUTES.HOME,
      pathName: GENERAL_CONSTANTS.ROUTES.HOME
    };
    this.findRoute(DASHBOARD_PRINCIPAL);
    this.routeMap.splice(0, 0, route);
  }

  findRoute(listCard: DashboardCard[]): boolean {
    return listCard.some(card => {
      const pathName = card.pathName || card.pathNameAux;
      if (
        (pathName && pathName == this.nameRoute) ||
        (card.children && this.findRoute(card.children))
      ) {
        if (pathName) {
          const route: RouteMapData = {
            title: card.title,
            pathName: pathName,
            urlUser: card.urlUser
          };
          this.routeMap.splice(0, 0, route);
        }
        return true;
      }
    });
  }

  actionClick(route: RouteMapData, crumble?: boolean) {
    const newRoute = Utils.calculeNewRoute(route);
    const validateServiceValidation = this.watchServiceOnChangeValidation();
    this.routeMapDataHandle = route;

    if (newRoute && !crumble) {
      if (validateServiceValidation) {
        this.crumbleValidation = true;
        this.dialogFormModal = true;
      } else {
        NavigationService.navigateByPath(newRoute);
      }
    } else if (crumble) {
      if (validateServiceValidation) {
        this.dialogFormModal = true;
      } else {
        this.handleProfileRoutes(route);
      }
    }
  }

  handleProfileRoutes(route: RouteMapData) {
    const indexRouteService = this.routeMap.findIndex(
      route => route.pathName == PROFILE_CRUMBS_CONSTANTS.ROUTES.SERVICE
    );
    if (
      route.pathName == PROFILE_CRUMBS_CONSTANTS.ROUTES.INITIAL &&
      indexRouteService != -1
    ) {
      store.commit(STORE_CONSTANTS.PROFILE_CRUMBS, {
        from: PROFILE_CRUMBS_CONSTANTS.FROM.ROUTE_MAP,
        type: PROFILE_CRUMBS_CONSTANTS.TYPE.SERVICE_REMOVED,
        action: PROFILE_CRUMBS_CONSTANTS.ACTION.UPDATE_ROUTE
      });
    }
  }

  handleModalAccept() {
    this.dialogFormModal = false;
    this.refreshServiceValidation();
    const newRoute = Utils.calculeNewRoute(this.routeMapDataHandle);
    if (!this.crumbleValidation) {
      this.handleProfileRoutes(this.routeMapDataHandle);
    } else {
      this.crumbleValidation = false;
      NavigationService.navigateByPath(newRoute!);
    }
  }

  handleModalCancel() {
    this.dialogFormModal = false;
    this.crumbleValidation = false;
  }
  refreshServiceValidation() {
    store.commit(STORE_CONSTANTS.SERVICE_CHANGE_VALIDATION, false);
    store.commit(STORE_CONSTANTS.REFRESH_SERVICE_TEMPLATE, true);
  }
}
